import React from 'react';
import classNames from 'classnames';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import PropTypes from 'prop-types';
import Title from 'Components/ComponentLibrary/Atoms/Text/Title';
import LinkIcon from '@material-ui/icons/Link';
import Subtitle from 'Components/ComponentLibrary/Atoms/Text/Subtitle';
import ResourceSummaryCard from 'Components/ComponentLibrary/Components/Uncategorized/ResourceSummaryCard';
import { plaidModal } from 'Consts/plaid';
import useMobileLayout from 'Hooks/useMobileLayout';

const useStyles = buildUseStyles('ApexFundingAccountResultContent', ((theme) => ({
  root: {
    width: '100%',
    maxWidth: plaidModal.width,
    height: '88vh',
    margin: 'auto',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  rootDesktop: {
    maxWidth: '600px',
    maxHeight: plaidModal.maxHeight,
  },
  body: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(3),
  },
  success: {
    color: theme.palette.success.main,
  },
  linkIconContainer: {
    borderRadius: '50%',
    padding: theme.spacing(3),
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.facet.accentGreen11,
  },
  linkIcon: {
    color: theme.palette.success.main,
    fontSize: 40,
  },
  subtitle: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(3.5),
  },
})));

const ApexFundingAccountResultContent = ({ className, resource }) => {
  const classes = useStyles();

  const isMobile = useMobileLayout();

  const isSuccess = resource.attr('status') === 'APPROVED';

  return (
    <Box
      className={classNames(classes.root, className, { [classes.rootDesktop]: !isMobile })}
    >
      <Box className={classes.body}>
        <Title
          className={classNames(classes.title, {
            [classes.success]: isSuccess,
          })}
          text={resource.attr('title')}
          test={'wizard-step-title'}
        />
        {isSuccess && (
          <Box className={classes.linkIconContainer}>
            <LinkIcon
              className={classes.linkIcon}
            />
          </Box>
        )}
        <Subtitle className={classes.subtitle} text={resource.attr('subtitle')} test={'wizard-step-subtitle'} />
        <ResourceSummaryCard resource={resource.attr('account').resources().head()} />
      </Box>
    </Box>
  );
};

ApexFundingAccountResultContent.defaultProps = {
  className: '',
};

ApexFundingAccountResultContent.propTypes = {
  className: PropTypes.string,
  resource: PropTypes.object.isRequired,
};

export default ApexFundingAccountResultContent;
